import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { VariantService } from 'src/app/admin-pages/variant.service';
import { BackOfficeService } from 'src/app/back-office-pages/back-office.service';
import { ApiService } from 'src/app/services/api.service';
import { ConfigService } from 'src/app/services/config.service';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';
import { environment } from 'src/environments/environment';
import { sideMenuItems } from '../../../../assets/tobeonlineMenu';
import { profileMenuItems } from '../../../../assets/tobeonlineMenu';

@Component({
  selector: 'app-tobeonline-side-menu',
  templateUrl: './tobeonline-side-menu.component.html',
  styleUrls: ['./tobeonline-side-menu.component.scss']
})
export class TobeonlineSideMenuComponent implements OnInit, OnDestroy{

  isSearchActive: boolean = false;
  isFilterActive: boolean = false;
  selectedShop: any = { key: 0, a: 'dssdf' };
  originalUser: any;
  loginDetails: any = {};
  isApiError: boolean;
  isShowLogOutConfirm: boolean;
  shopList: any = [{ ShopName: 'All', ID: 0 }];
  CartCount: number = 0;
  selectedUser: any = {};
  isRouteUser: boolean;
  iSelectedRoute: boolean;
  loggedInUserID: number = 0;
  isShowReportList: boolean = false;

  isSuperAdmin!: boolean;
  isSelectedSuper!: boolean;
  adminDetails: any;

  isReseller!: boolean;
  shopeDomainName: any;
  appName: string;
  registrationData: any;
  isCollapsed: boolean = true;
  isThirdParty: boolean = false;
  isServicenearSuperAdmin: boolean = false;
  private subscriptionsToUnsubscribe = new Subscription();
  profileMenu: boolean = false;
  menuItemsList: any = sideMenuItems;
  profileMenuList: any = profileMenuItems;
  
  get enabledMenuItems(): any[] {
    return this.menuItemsList.filter((menuItem: any) => !menuItem.hidden && !menuItem.disabled);
  }

  get disabledMenuItems(): any[] {
    return this.menuItemsList.filter((menuItem: any) => !menuItem.hidden && menuItem.disabled);
  }

  toggleItem(item: any): void {
    item.expanded = !item.expanded;
  }

  trackById(index: number, item: any): string {
    return item.id;
  }

  constructor(
    private router: Router,
    private backOfficeService: BackOfficeService,
    public apiService: ApiService,
    private vs: VariantService,
    // private fcmService: FcmServ0ice,
    public configService: ConfigService,
    private subscriptionsService: SubscriptionsService,
  ) {
    this.isReseller = this.configService.isReseller;
  }

  ngOnInit(): void {
    this.setUpUser();
    const user = this.apiService.getSelectedUser();
    this.loggedInUserID = user?.ID ?? 0;
    this.adminDetails = this.apiService.getRealUserData();

    if (window.location.href.includes(environment.thirdPartyUserKey) && window.location.href.includes(environment.thirdPartyAppURL)) {
      this.isThirdParty = true;
    }

    // Subscribe to mobile menu config from API
    const subsSub = this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features?.mobilemenu) {
        this.setMobileMenuConfig(features.mobilemenu);
      }
    });
    this.subscriptionsToUnsubscribe.add(subsSub);

    const whatsNewMenu = this.menuItemsList.find(
      (menuItem: any) => menuItem.id === 'whatsnew'
    );
    whatsNewMenu.description = whatsNewMenu.description + this.configService.version;
  }

  ngOnDestroy(): void {
    this.subscriptionsToUnsubscribe.unsubscribe();
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";

  }

  public gotoPage(path) {
    if(path.includes('logout')){
      this.logOutClicked()
    }else{
      this.router.navigate([path]);
      this.closeSideNav();
    }
  }

  showReports(event: boolean) {
    if (this.isShowReportList === false) {
      this.isShowReportList = true;
    } else {
      this.isShowReportList = false;
    }
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
    this.closeSideNav();
    // this.modalService.open(logoutTemplate, false, this.isShowLogOutConfirm);
  }


  public confirmLogOut() {
    // let appVersion = localStorage.getItem('appVersion') != null ? localStorage.getItem('appVersion') : 0;
    let appConfig = localStorage.getItem("appConfig");
    let uuid = localStorage.getItem("uuid");
    // this.fcmService.unsubscribeNotification();
    // this.fcmService.deregisterServiceWorker();

    localStorage.clear();

    // localStorage.setItem('appVersion', appVersion.toString());
    localStorage.setItem('appConfig', appConfig);
    uuid ? localStorage.setItem('uuid', uuid) : '';

    this.router.navigate(['/public/login']);
  }

  public clearUserSelection() {
    this.backOfficeService.clearCustomerSelection();
    this.setUpUser();
    this.gotoPage('/user/userlist');
  }

  private setUpUser() {
    this.selectedUser = this.apiService.getSelecterUserData();
    this.originalUser = this.apiService.getRealUserData();

    this.isRouteUser = this.originalUser?.UserType === 'admin' ? true : false; //removed soon
    this.iSelectedRoute =
      this.selectedUser?.UserType === 'admin' ? true : false; //removed soon

    this.isSuperAdmin =
      this.originalUser.UserType == 'superadmin' ? true : false;
    this.isSelectedSuper =
      this.selectedUser.UserType == 'superadmin' ? true : false;

    // Superadmin check
    if (Number(this.originalUser.SellerID) === 3) {
      this.isSuperAdmin=false;
      this.isServicenearSuperAdmin = true;
    }

    if(this.isSuperAdmin){
      const sellerListItem = this.menuItemsList.find(item => item.id === "sellers");
      sellerListItem.hidden = false;
    }else if(this.isServicenearSuperAdmin){
      const servicenearSellersItem = this.menuItemsList.find(item => item.id === "servicenearSellers");
      servicenearSellersItem.hidden = false;
    }
  }

  get profileName() {
    let adminDetails = JSON.parse(localStorage.getItem('admin_Details') || '{}');
    return adminDetails?.Name;
  }

  public gotoAddProduct() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      if (location.hash.split('/')[2] == "product-edit") {
        this.vs.initVariantService(0);
      }
      this.router.navigate(['/products/product-edit', 0]);
    }
    this.closeSideNav();
  }

  ShareMyStore() {
    const shopeDomainName = this.configService.getLoginDetails()?.SubDomain;
    const appName = environment.appName.toLowerCase();
    const shareableLink = `https://${shopeDomainName}`;

    if (shopeDomainName && appName) {
      if (navigator.share) {
        navigator.share({
          title: 'Share My Store',
          text: 'Check out my store',
          url: shareableLink,
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    } else {

    }
    this.closeSideNav();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  public showProfileOptions(){
    this.profileMenu = !this.profileMenu;
  }

  public closeProfileOptions(){
    this.profileMenu = false;
  }

  private setMobileMenuConfig(apiMenu: any[]): void {
    // Reset to original sideMenuItems so re-calls don't compound mutations
    this.menuItemsList = sideMenuItems.map((menuItem: any) => ({ ...menuItem,
      children: menuItem.children ? menuItem.children.map((c: any) => ({ ...c })) : undefined
    }));

    // Re-apply superadmin visibility after reset
    if (this.isSuperAdmin) {
      const sellerListItem = this.menuItemsList.find((menuItem: any) => menuItem.id === 'sellers');
      if (sellerListItem) { sellerListItem.hidden = false; }
    } else if (this.isServicenearSuperAdmin) {
      const servicenearSellersItem = this.menuItemsList.find((menuItem: any) => menuItem.id === 'servicenearSellers');
      if (servicenearSellersItem) { servicenearSellersItem.hidden = false; }
    }

    // Re-apply whatsnew description
    const whatsNewMenu = this.menuItemsList.find((menuItem: any) => menuItem.id === 'whatsnew');
    if (whatsNewMenu?.description && !whatsNewMenu.description.includes(this.configService.version)) {
      whatsNewMenu.description = whatsNewMenu.description + this.configService.version;
    }

    this.menuItemsList.forEach((menuItem: any) => {
      const apiMenuItem = apiMenu.find((m: any) => m.id === menuItem.id);

      if (apiMenuItem) {
        // ── Parent rules
        menuItem.hidden   = !apiMenuItem.show;
        menuItem.disabled = apiMenuItem.disable;

        // ── Children rules (only when parent is visible)
        if (!menuItem.hidden && menuItem.children && apiMenuItem.children?.length) {
          menuItem.children.forEach((childItem: any) => {
            const apiChildItem = apiMenuItem.children.find((c: any) => c.id === childItem.id);
            if (apiChildItem) {
              childItem.hidden   = !apiChildItem.show;
              childItem.disabled = apiChildItem.disable;
            }
          });

          // Remove hidden children
          menuItem.children = menuItem.children.filter((childItem: any) => !childItem.hidden);

          // Sort children by positionindex
          menuItem.children.sort((a: any, b: any) =>
            (a.positionindex ?? Number.MAX_SAFE_INTEGER) - (b.positionindex ?? Number.MAX_SAFE_INTEGER)
          );
        }

        // ── Force children disabled
        if (menuItem.disabled && menuItem.children?.length) {
          menuItem.children.forEach((child: any) => {
            child.disabled = true;
          });
        }
      }
    });

    // Remove hidden parents
    this.menuItemsList = this.menuItemsList.filter((menuItem: any) => !menuItem.hidden);

    // Sort parents by positionindex
    this.menuItemsList.sort((a: any, b: any) =>
      (a.positionindex ?? Number.MAX_SAFE_INTEGER) - (b.positionindex ?? Number.MAX_SAFE_INTEGER)
    );
  }
}
